<template>
	<div class="success" id="index">
		<div class="topinfo">您已成功领取《小学生绘本课堂·素材书》，您的赠书将于2020年6月6日统一寄出，请注意查收。在直播间购买任意产品的家长，赠书将随产品寄达。</div>
		<div class="box">
			<img class="product" src="@assets/images/primary_product.jpg" alt="">
			<div class="gocar" @click="goCat(1,80)">
				<img src="@assets/images/gocar.png">
			</div>
			<Product-window v-on:changeFun="changeFun" :attr="attr" :type="0" :productid="productid"></Product-window>
		</div>
		<!-- 弹框 -->
		<!-- <div id="mask" v-show="maskshow"> -->
			<!-- 200元优惠券 -->
			<!-- <div v-show="isshow200" class="mask_box mask_box1">
				<img src="@assets/images/mask_img1.png" alt="">
				<div @click="sign(jump_url)" class="boxbutton sign">去签约</div>
				<div @click="buyBook()" class="boxbutton buybook">仍购书</div>
			</div> -->
			<!-- 1000元优惠券 -->
			<!-- <div  v-show="isshow1000" class="mask_box mask_box2">
				<img src="@assets/images/mask_img2.png" alt="">
				<div @click="sign(jump_url)" class="boxbutton sign">去签约</div>
				<div @click="buyBook()" class="boxbutton buybook">仍购书</div>
			</div> -->
			<!-- <img @click="closeMask()" class="maskclose" src="@assets/images/maskclose.png"> -->
		<!-- </div> -->
	</div>
</template>

<script>
import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getProductCode,
  storeListApi
} from "@api/store";
import {
  getCoupon,
  getCollectAdd,
  getCollectDel,
  getUserInfo,
  getQuesCoupon,
  QuesCoupon
} from "@api/user";
import ProductWindow from "@components/ProductWindow";

export default{
	name:"PrimarySuccess",
	data:function(){
		return{
			maskshow:false,
			jump_status:1,
			button_status:1,
			isshow200:false,
			isshow1000:false,
			jump_url:"",
			//立即购买
			productid:0,
			shareInfoStatus: false,
			weixinStatus: false,
			mapShow: false,
			mapKey: "",
			posterData: {
			  image: "",
			  title: "",
			  price: "",
			  code: ""
			},
			posterImageStatus: false,
			animated: false,
			coupon: {
			  coupon: false,
			  list: []
			},
			attr: {
			  cartAttr: false,
			  productAttr: [],
			  productSelect: {},
					RuleData:{}
			},
			RuleDatares:[],
			isOpen: false, //是否打开属性组件
			productValue: [],
			id: 0,
			storeInfo: {},
			couponList: [],
			attrTxt: "请选择",
			attrValue: "",
			cart_num: 1, //购买数量
			replyCount: "",
			replyChance: "",
			reply: [],
			priceName: 0,
			CartCount: 0,
			posters: false,
			swiperRecommend: {
			  pagination: {
			    el: ".swiper-pagination",
			    clickable: true
			  },
			  autoplay: false,
			  loop: false,
			  speed: 1000,
			  observer: true,
			  observeParents: true
			},
			goodList: [],
			system_store: {},
			storeSelfMention: true,
			storeItems: {},
			activity: [],
			navList: [],
			lock: false,
			navActive: 0,
			opacity: 0
		}
	},
	components: {
		ProductWindow
	},
	mounted: function() {
		var winHeight = window.screen.availHeight;
		var thisHeight = document.getElementById("index");
		var maskHight = document.getElementById("mask");
		thisHeight.style.height = winHeight + "px";
		maskHight.style.height = winHeight + "px";
		this.getQuesCoupon();
	},
	methods:{
		//一进页面访问
		getQuesCoupon:function(){
			let that = this;
			let data = that.$route.params;
			getQuesCoupon(data).then(function(res){
				that.jump_status = res.data.jump_status;
				that.button_status = res.data.button_status;
			}).catch(function(err){
				if(err.msg == "领取的优惠劵已过期!"){
					window.location.href = "https://tmall.fc62.com/end_activity.html";
				}else{
					that.$dialog.error(err.msg);
				}
			});
		},
		
		//去签约
		sign:function(jump_url){
			window.location.href = jump_url;
		},
		//仍购书
		buyBook:function(){
			this.maskshow = false;
			window.scroll(0, 100);
		},
		//关闭弹框
		closeMask: function(){
			this.maskshow = false;
		},
		//购物车；
		ChangeCartNum: function(changeValue) {
		  //changeValue:是否 加|减
		  //获取当前变动属性
		  let productSelect = this.productValue[this.attrValue];
		  //如果没有属性,赋值给商品默认库存
		  if (productSelect === undefined && !this.attr.productAttr.length)
		    productSelect = this.attr.productSelect;
		  //无属性值即库存为0；不存在加减；
		  if (productSelect === undefined) return;
		  let stock = productSelect.stock || 0;
		  let num = this.attr.productSelect;
		  if (changeValue) {
		    num.cart_num++;
		    if (num.cart_num > stock) {
		      this.$set(this.attr.productSelect, "cart_num", stock);
		      this.$set(this, "cart_num", stock);
		    }
		  } else {
		    num.cart_num--;
		    if (num.cart_num < 1) {
		      this.$set(this.attr.productSelect, "cart_num", 1);
		      this.$set(this, "cart_num", 1);
		    }
		  }
		},
		//将父级向子集多次传送的函数合二为一；
		changeFun: function(opt) {
		  console.log(opt);
		  var that = this;
		  if(opt.action == "ChangeSubject"){
			that.RuleDatares = opt.value;
		  }
		  if(opt.action == "define"){
			that.goCat(1,opt.value);
		  }
		  if (typeof opt !== "object") opt = {};
		  let action = opt.action || "";
		  let value = opt.value === undefined ? "" : opt.value;
		  this[action] && this[action](value);
		},
		//判断属性是否可选
		isCheckedValue: function(type){
		  let that = this;
		  let productAttr = this.attr.productAttr;
		  let return_d = true
		  if(type != 1){
		     return_d = false;
		  }
		  for (let i = 0; i < productAttr.length; i++) {
		    for (let j = 0; j < productAttr[i].attr_value.length; j++) {
		       //console.log(productAttr[i].index+'4444444444');
		      if (productAttr[i].index === productAttr[i].attr_value[j].attr) {
		        //console.log(type+'---------333333');
		        if(productAttr[i].attr_value[j].disabled_info){
		           for (var key in productAttr[i].attr_value[j].disabled_info_data) {
		              for(var ke in productAttr[i].attr_value[j].disabled_info_data[key]){
		               // console.log(productAttr[i].attr_value[j].disabled_info_data[key][ke]);
		                //console.log(ke);
		                this.attr.productAttr[key]['attr_value'][ke]['disabled'] = return_d;
		              }
		              //console.log(productAttr[i].attr_value[j].disabled_info_data[key]);
		            }
		        }
		      }
		    }
		  }
		  // if(!that.attr.productValue[value.join(",")]){
		  //   that.isChecked = false;
		  // }
		  //return that.isChecked;
		},
		//打开属性插件；
		selecAttrTap: function() {
		  this.attr.cartAttr = true;
		  this.isOpen = true;
		},
		changeattr: function(msg) {
		  this.attr.cartAttr = msg;
		  this.isOpen = false;
		},
		//选择属性；
		ChangeAttr: function(res) {
		  let productSelect = this.productValue[res];
		  if (productSelect) {
		    this.$set(this.attr.productSelect, "image", productSelect.image);
		    this.$set(this.attr.productSelect, "price", productSelect.price);
		    this.$set(this.attr.productSelect, "stock", productSelect.stock);
		    this.$set(this.attr.productSelect, "unique", productSelect.unique);
		    this.$set(this.attr.productSelect, "cart_num", 1);
		    this.$set(this, "attrValue", res);
		    this.$set(this, "attrTxt", "已选择");
		  } else {
		    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
		    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
		    this.$set(this.attr.productSelect, "stock", 0);
		    this.$set(this.attr.productSelect, "unique", "");
		    this.$set(this.attr.productSelect, "cart_num", 0);
		    this.$set(this, "attrValue", "");
		    this.$set(this, "attrTxt", "请选择");
		  }
		},
		//默认选中属性；
		DefaultSelect: function() {
		  let productAttr = this.attr.productAttr,
		    value = [];
		  for (var key in this.productValue) {
		    if (this.productValue[key].stock > 0) {
		      value = this.attr.productAttr.length ? key.split(",") : [];
		      break;
		    }
		  }
		  for (let i = 0; i < productAttr.length; i++) {
		    this.$set(productAttr[i], "index", value[i]);
		  }
		  //sort();排序函数:数字-英文-汉字；
		  let productSelect = this.productValue[value.join(",")];
		  if (productSelect && productAttr.length) {
		    this.$set(
		      this.attr.productSelect,
		      "store_name",
		      this.storeInfo.store_name
		    );
		    this.$set(this.attr.productSelect, "image", productSelect.image);
		    this.$set(this.attr.productSelect, "price", productSelect.price);
		    this.$set(this.attr.productSelect, "stock", productSelect.stock);
		    this.$set(this.attr.productSelect, "unique", productSelect.unique);
		    this.$set(this.attr.productSelect, "cart_num", 1);
		    // this.$set(this, "attrValue", value.sort().join(","));
		    this.$set(this, "attrValue", value.join(","));
		    this.$set(this, "attrTxt", "已选择");
		  } else if (!productSelect && productAttr.length) {
		    this.$set(
		      this.attr.productSelect,
		      "store_name",
		      this.storeInfo.store_name
		    );
		    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
		    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
		    this.$set(this.attr.productSelect, "stock", 0);
		    this.$set(this.attr.productSelect, "unique", "");
		    this.$set(this.attr.productSelect, "cart_num", 0);
		    this.$set(this, "attrValue", "");
		    this.$set(this, "attrTxt", "请选择");
		  } else if (!productSelect && !productAttr.length) {
		    this.$set(
		      this.attr.productSelect,
		      "store_name",
		      this.storeInfo.store_name
		    );
		    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
		    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
		    this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
		    this.$set(
		      this.attr.productSelect,
		      "unique",
		      this.storeInfo.unique || ""
		    );
		    this.$set(this.attr.productSelect, "cart_num", 1);
		    this.$set(this, "attrValue", "");
		    this.$set(this, "attrTxt", "请选择");
		  }
		  this.isCheckedValue(1);
		},
		// 加入购物车；
		goCat: function(news,id) {
		  let that = this;
		 //  if(that.button_status == 1){
			// that.$dialog.toast({mes:"请领取上方优惠券后再进行购买"});
			// return;
		 //  }
		  document.getElementById("index").classList.add("noscoll");
		  this.productCon(id);
		  let  productSelect = that.productValue[this.attrValue];
		  console.log(that.RuleDatares);
		  that.$set(that, "productid", id);
		 //打开属性
		 if (that.attrValue) {
		   //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
		   // that.attr.cartAttr = !that.isOpen ? true : false;
					that.attr.cartAttr = true;
		 } else {
		   if (that.isOpen) that.attr.cartAttr = true;
		   else that.attr.cartAttr = !that.attr.cartAttr;
		 } 
		  //只有关闭属性弹窗时进行加入购物车
		  if (that.attr.cartAttr === true && that.isOpen === false)
		    return (that.isOpen = true);
		  if (
		    !this.attr.productSelect.cart_num ||
		    parseInt(this.attr.productSelect.cart_num) <= 0
		  )
		    return that.$dialog.toast({ mes: "请输入购买数量" });
				
				let q = {
				  productId: id,
				  cartNum: that.attr.productSelect.cart_num,
				  spec_type:that.attr.RuleData.spec_type,
				  spec_values:that.attr.RuleData.spec_type == 1 ? that.RuleDatares.join(',') : "",
				  new: news,
				  uniqueId:
					that.attr.productSelect !== undefined
					  ? that.attr.productSelect.unique
					  : ""
				};
		  if(that.attr.RuleData.spec_type == 1){
			  var checkedarr = that.attr.RuleData.attr_values[that.attr.productAttr[0].index];
			  var check_num = [];
			  for(var i = 0; i < checkedarr.length; i++){
				  if(checkedarr[i].check){
					  check_num.push(checkedarr[i].check);
				  }
			  }
			  console.log(check_num.length);
			  var sepc_num = that.attr.RuleData.attr_value[that.attr.productAttr[0].index].sepc_num;
			  if(check_num.length < sepc_num || q.spec_values == ""){
				  that.$layer.msg("选择科目不能小于"+sepc_num+"科");
			  }else{
				  postCartAdd(q).then(function(res) {
					  console.log(res);
					  that.isOpen = false;
					  that.attr.cartAttr = false;
						  document.getElementById("index").classList.remove("noscoll");
					  if (news) {
						that.$router.push({ path: "/order/submit/" + res.data.cartId });
					  } else {
							  that.$dialog.toast({
								mes: "添加购物车成功",
								callback: () => {
								  that.getCartCount(true);
								}
							  });
					  }
				   }).catch(res => {
					  that.isOpen = false;
					  return that.$dialog.toast({ mes: res.msg });
				   });
			  }
		  }else{
			  postCartAdd(q).then(function(res) {
				  that.isOpen = false;
				  that.attr.cartAttr = false;
					  document.getElementById("index").classList.remove("noscoll");
				  if (news) {
					that.$router.push({ path: "/order/submit/" + res.data.cartId });
				  } else {
					  that.$dialog.toast({
						mes: "添加购物车成功",
						callback: () => {
						  that.getCartCount(true);
						}
					  });
				  }
			   }).catch(res => {
			  		that.isOpen = false;
			  		return that.$dialog.toast({ mes: res.msg });
			   });
		  }
		},
		// getImageBase64: function() {
		//   let that = this;
		//   imageBase64(this.posterData.image, that.posterData.code)
		//     .then(res => {
		//       that.posterData.image = res.data.image;
		//       that.posterData.code = res.data.code;
		//       that.isLogin && that.shareCode();
		//     })
		//     .catch(() => {
		//       that.isLogin && that.shareCode();
		//     });
		// },
		//产品详情接口；
		productCon: function(id) {
		  let that = this;
		  getProductDetail(id).then(res => {
					console.log("成功")
		      that.$set(that, "storeInfo", res.data.storeInfo);
		        that.$set(that.attr, "productAttr", res.data.productAttr);
		        that.$set(that.attr, "RuleData", res.data.RuleData);
		        that.$set(that, "productValue", res.data.productValue);
		        that.$set(that, "replyCount", res.data.replyCount);
		        that.$set(that, "replyChance", res.data.replyChance);
		        that.reply = res.data.reply ? [res.data.reply] : [];
		        that.$set(that, "reply", that.reply);
		        that.$set(that, "priceName", res.data.priceName);
		        that.posterData.image = that.storeInfo.image_base;
		        that.activity = res.data.activity ? res.data.activity : [];
		        if (that.storeInfo.store_name.length > 30) {
		          that.posterData.title =
		            that.storeInfo.store_name.substring(0, 30) + "...";
		        } else {
		          that.posterData.title = that.storeInfo.store_name;
		        }
		        that.storeSelfMention = res.data.store_self_mention ? true : false;
		        that.posterData.price = that.storeInfo.price;
		        that.posterData.code = that.storeInfo.code_base;
		        that.system_store = res.data.system_store;
		        let good_list = res.data.good_list || [];
		        let goodArray = [];
		        let count = Math.ceil(good_list.length / 6);
		        for (let i = 0; i < count; i++) {
		          var list = good_list.slice(i * 6, i * 6 + 6);
		          if (list.length) goodArray.push({ list: list });
		        }
		        that.mapKey = res.data.mapKey;
		        that.$set(that, "goodList", goodArray);
		        let navList = ["商品", "评价", "详情"];
		        if (goodArray.length) {
		          navList.splice(2, 0, "推荐");
		        }
		        that.navList = navList;
		        that.DefaultSelect();
		        that.getCartCount();
		        // that.getImageBase64();
		        if(that.attr.RuleData.spec_type == 1){
		      	  // that.getsubject();
		        }
		      }).catch(res => {
						console.log("失败111111")
		        that.$dialog.error(res.msg);
		      });
		},
		//获取被选中科目
		getsubject: function(){
			let that = this;
			let RuleData = that.attr.RuleData.attr_values[that.attr.productAttr[0].index];
				console.log("获取被选中科目");
				console.log(RuleData)
			let value = [];
			for(let i=0;i<RuleData.length;i++){
				if(RuleData[i].check){
					value.push(RuleData[i].attr);
				}
			}
			that.RuleDatares = value;
		},
		//获取购物车数量
		getCartCount: function(isAnima) {
		  let that = this;
		  const isLogin = that.isLogin;
		  if (isLogin) {
		    getCartCount({ numType: 0 }).then(res => {
		      that.CartCount = res.data.count;
		      //加入购物车后重置属性
		      if (isAnima) {
		        that.animated = true;
		        setTimeout(function() {
		          that.animated = false;
		        }, 500);
		      }
		    });
		  }
		}
	}
}
</script>

<style scoped>
.noscoll{
	height: 100%;
	overflow: hidden;
}
.success{
	padding: 0.3rem;
	/* background: url(../../assets/images/success_bg.jpg) no-repeat; */
	background-size: 100% 100%;
	background-color: #f2211c;
}
.topinfo{
	background-color: #f5ef75;
	border-radius: 5px;
	font-size: 0.28rem;
	padding: 0.4rem 0.3rem;
	line-height: 0.43rem;
	color: #000;
}
.box{
	background-color: #fff;
	margin-top: 0.28rem;
	border-radius: 5px;
	position: relative;
	overflow: hidden;
	padding: 0 0.4rem;
}
.coupon{
	width: 87%;
	display: block;
	margin: 0.6rem auto;
}
img.product{
	width: 100%;
	display: block;
	margin-bottom: 0.6rem;
	margin-top: 0.4rem;
}
.gocar{
	position: absolute;
	bottom: 5%;
	right: 6%;
	border-radius: 50%;
}
.gocar img{
	width: 0.89rem;
	height: 0.89rem;
}
#mask{
	background: rgba(0,0,0,0.7);
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 998;
}
.mask_box{
	z-index: 999;
	width: 77%;
	margin: 45% auto;
	margin-bottom: 0;
	position: relative;
}
.mask_box img{
	width: 100%;
}
.hide{
	display: none;
}
.boxbutton{
	position: absolute;
	bottom: 0.45rem;
	border-radius: 12px;
	width: 1.7rem;
	height: 0.5rem;
	line-height: 0.5rem;
	text-align: center;
	color: #fff;
}
.sign{
	background-color: #0aabff;
	left: 13%;
}
.buybook{
	background-color: #fe8300;
	left: 55%;
}
.maskclose{
	display: block;
	width: 0.68rem;
	height: 0.68rem;
	margin: 10% auto;
}
</style>
